// extracted by mini-css-extract-plugin
export default {"wrapper":"with-css-wrapper-module--wrapper--48bd8"};